import { MainLayout } from 'src/layouts'
import Image from 'next/image'
import { formatDate } from 'src/utils/time/moment.helper'
import { WEBSITE } from 'src/consts'
import styles from './styles.module.scss'
import Head from 'next/head'
import { intl } from 'src/i18n'
import { usePressReleases } from 'src/state'
import React from 'react'

const PressReleases = () => {
  const news = usePressReleases().data
  return (
    <MainLayout fixedHeader>
      <Head>
        <meta name='robots' content='noindex' />
      </Head>
      <div className={styles.container}>
        <div className={styles.pressReleasesList}>
          <h1 className={styles.header}>{intl.t('pressReleases.header')}</h1>
          <div>
            {news.map(
              ({ id, title, fulltext, published_at, thumb, fromCMS }) => {
                return (
                  <div className={styles.pressReleasesItem} key={id}>
                    <div className={styles.pressReleasesListItemTitle}>
                      {title}
                    </div>
                    <div
                      className={styles.pressReleasesListItemSubTitle}
                    >{`${formatDate(published_at, 'MMMM dd, yyyy')}`}</div>
                    {thumb ? (
                      <div className={styles.pressReleasesListImage}>
                        <Image
                          src={thumb.replace(
                            'https://s3.cointelegraph.com',
                            'https://coin360.com'
                          )}
                          alt={`${title}`}
                          width={700}
                          height={466}
                        />
                      </div>
                    ) : (
                      <div className={styles.emptyImage}>
                        <div className={styles.emptyImageHead}>
                          <div className={styles.emptyImageDate}>
                            {formatDate(published_at, 'MMMM dd, yyyy')}
                          </div>
                          <div className={styles.emptyImageTittle}>{title}</div>
                        </div>
                      </div>
                    )}
                    {fromCMS ? (
                      <div
                        className={styles.pressReleasesListItemDescription}
                        dangerouslySetInnerHTML={{
                          __html: fulltext,
                        }}
                      />
                    ) : (
                      <div
                        className={styles.pressReleasesListItemDescription}
                        dangerouslySetInnerHTML={{
                          __html: fulltext
                            .replace(/style="[^"]*"/g, '')
                            .replace(
                              /(https:\/\/s3\.cointelegraph\.com)/g,
                              WEBSITE
                            ),
                        }}
                      />
                    )}
                  </div>
                )
              }
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  )
}

export default PressReleases
